/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleGroup
 */
export interface VehicleGroup {
    /**
     * 
     * @type {string}
     * @memberof VehicleGroup
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleGroup
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof VehicleGroup
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleGroup
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleGroup
     */
    assignedVehicleCount: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleGroup
     */
    assignedUserGroupCount: number;
}

/**
 * Check if a given object implements the VehicleGroup interface.
 */
export function instanceOfVehicleGroup(value: object): value is VehicleGroup {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('assignedVehicleCount' in value) || value['assignedVehicleCount'] === undefined) return false;
    if (!('assignedUserGroupCount' in value) || value['assignedUserGroupCount'] === undefined) return false;
    return true;
}

export function VehicleGroupFromJSON(json: any): VehicleGroup {
    return VehicleGroupFromJSONTyped(json, false);
}

export function VehicleGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'label': json['label'],
        'assignedVehicleCount': json['assignedVehicleCount'],
        'assignedUserGroupCount': json['assignedUserGroupCount'],
    };
}

export function VehicleGroupToJSON(json: any): VehicleGroup {
    return VehicleGroupToJSONTyped(json, false);
}

export function VehicleGroupToJSONTyped(value?: VehicleGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'label': value['label'],
        'assignedVehicleCount': value['assignedVehicleCount'],
        'assignedUserGroupCount': value['assignedUserGroupCount'],
    };
}

